import { render, staticRenderFns } from "./bookmark-list.vue?vue&type=template&id=2a7aeedc&scoped=true&"
import script from "./bookmark-list.vue?vue&type=script&lang=ts&"
export * from "./bookmark-list.vue?vue&type=script&lang=ts&"
import style0 from "./bookmark-list.vue?vue&type=style&index=0&id=2a7aeedc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7aeedc",
  null
  
)

export default component.exports